<template>
    <v-card>
      <v-card-title class="">
        <div>
          <span class="headline black--text">Assigned Teams to Project</span>
        </div>
      </v-card-title>
      <v-card-text>
        <div>
          <v-card
            v-for="(team_data, index1) in teams"
            v-bind:key="index1">
            <v-card-text>
              {{ getTeamInfo(team_data) }}
            </v-card-text>
            
          </v-card>
        </div>
      </v-card-text>
      <v-card-text>
        Available Dasher on this Teams are: {{ numberOfDasherAvailable }}
      </v-card-text>
    </v-card>
</template>

<script>
import axios from 'axios';
import {ROOT_URL} from '@/api/connectingUrls';

export default {
   props: {
    project_id: Number,
  },
  data: () => ({
    apiUrl: "project-team-info",
    teams:[],
  }),
  computed: {
    
    binding() {
      const binding = {};
      if (this.$vuetify.breakpoint.mdAndUp) binding.column = true;

      return binding;
    },
    numberOfDasherAvailable(){
      var totalDasher=0;
      this.teams.forEach(element => {
        totalDasher += element.numbers_of_dasher;
      });
      return totalDasher;
    }    
  },
  created() {
    
    this.getComponent(this.project_id);
  },

  methods: {
    getComponent(projectId){
        
      try {
          const token = window.localStorage.getItem('datadash_token');
          if(token != null){ 
          return axios.get(`${ROOT_URL}/${this.apiUrl}/${projectId}`,{
              headers:{
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json'
              }
          })
          .then(response => {
          if (response.data.statusCode == 200){
              // console.log(response);
              this.teams=response.data.data.teams;
          }
        })
        }}catch (error) {
            // console.log(error);
        }
      },

    getTeamInfo(teamData){
      var teamText = "";
      teamText =
        "Group Name: " +
        teamData.team_name +
        "\n Group Code: " +
        teamData.team_code +
        " \n Number Of agent: " +
        teamData.numbers_of_dasher;
      return teamText;
    },
  },
};
</script>

<style scoped>
.headline {
  color: white;
}
.project {
  background: #ff2e2e;
}
</style>